import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import softDeleteDocument from "astrid-firestore/src/api/documents/softDeleteDocument";

import { useProfile } from "../../../../authentication/state/profile";
import { getOrganizationPath } from "../../../../routing/utils/getOrganizationPath";

export default function useContractorsDropdownMenuOptions() {
	const { t } = useTranslation();
	const user = useProfile();

	return (contractor) => [
		{
			text: t("view", "View"),
			linkTo: getOrganizationPath(`/settings/contractors/${contractor.id}`),
		},
		{
			text: t("delete", "Delete"),
			confirmText: t("deleteContractorConfirmation", "Are you sure you want to delete this contractor?"),
			action: () => {
				return softDeleteDocument(firebase, contractor, user);
			},
		},
	];
}
